import { ResponseModal2Component } from './../../../components/response-modal2/response-modal2.component';
import { Component, OnInit, Injectable, Inject } from '@angular/core';
import { NgbActiveModal, NgbDatepickerI18n, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchInvoicesService } from '../../../services/search-invoices.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { WebStorageService, LOCAL_STORAGE } from 'angular-webstorage-service';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../../../services/storage.service';
import { ToasterService } from 'angular5-toaster';

@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }
}


@Component({
  selector: 'app-send-files',
  templateUrl: './send-files.component.html',
  styleUrls: ['./send-files.component.scss'],
  providers: [I18n]
})
export class SendFilesComponent implements OnInit {

  xml: boolean = false;
  pdf: boolean = false;
  emails: string = "";
  passedData: Array<any>;
  tipoConsultaPassed: any;
  form: FormGroup;
  invalidEmail: boolean = false;
  busyBusqueda: boolean = false;
  emailEnviado: string = "";

  tituloEnvioCorreo;
  errorDescargaFactura;

  constructor(
    private translate: TranslateService,
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
    private facturaRemService: SearchInvoicesService,
    private toasterService: ToasterService,
    private storageService: StorageService) {
      this.translate.get('texto.informacionEnviada').subscribe(
        text => {
          this.tituloEnvioCorreo = text;
        });

      this.translate.get('texto.errorDescargaFactura').subscribe(
        text => {
          this.errorDescargaFactura = text;
        });
     }

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    })
  }

  enviar() {
    // console.log(this.xml);
    // console.log(this.pdf);
    // console.log(this.passedData);
    this.busyBusqueda = true;
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    let band: boolean = true;
    let validE = this.emails.split(",");

    validE.forEach(element => {
      element = element.trim();
      if (element.match(mailformat)) {
        band = true;
      }
      else {
        band = false;
      }
    });
    
    if (!band) {
      this.invalidEmail = true;
      this.busyBusqueda = false;
      return false;
    } else {
      this.invalidEmail = false;
      if (this.xml || this.pdf) {
        this.facturaRemService.enviarFacturasEmail(this.passedData, this.emails.split(","),false, this.xml, this.pdf, this.tipoConsultaPassed).subscribe(
          data => {
            // console.log(data);
            if(data.mensaje == 'Email enviado'){
              this.busyBusqueda = false;
              this.emailEnviado = data.mensaje;
              setTimeout(() => {
                this.activeModal.close();  
              }, 2000);
                const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
                modalRef.componentInstance.titulo = this.tituloEnvioCorreo;
                modalRef.componentInstance.mensaje1 = data.mensaje;
            }
          },
          error => {
            this.busyBusqueda = false;
            if (error.status === 401) {
              this.storageService.openLogout();
            }
             else if (error.status === 501) {
              this.toasterService.pop('error', this.errorDescargaFactura);
            } 
            else if (error.status === 500) {
              this.toasterService.pop('error', this.errorDescargaFactura);
            }
            else {
              console.log(error);
            }
          }
        )
      } else {
        this.busyBusqueda = false;
      }
    }
  }


  closeModal() {
    this.activeModal.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/account-status/send-files/send-files.component.ts